<div class="app-page">
  <div class="app-page-content">
    <section class="app-card">
      <header class="mb-6 flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
        <div class="flex flex-col gap-1">
          <h1 class="section-title">Órdenes de Publicidad</h1>
          <p class="section-subtitle">
            Listado y gestión de órdenes
          </p>
        </div>

        <div class="flex flex-wrap items-center gap-2">
          <span class="app-badge">
            <strong>{{ totalRecords() }}</strong> órdenes
          </span>
          <span
            class="app-badge"
            [ngClass]="{
              'app-badge-primary': !paginate
            }">
            {{ paginate ? 'Paginado' : 'Todos' }}
          </span>
        </div>
      </header>

      <p-table
        #dt
        [value]="ordenes()"
        [columns]="columnsTable"
        dataKey="id"
        sortMode="multiple"
        [(selection)]="selectedRows"
        [loading]="loading()"
        [rowHover]="true"
        [lazy]="true"
        (onLazyLoad)="loadLazy($event)"
        styleClass="app-table-container"
        [paginator]="paginate"
        [rows]="nroFilasPorPagina"
        [totalRecords]="totalRecords()"
        [filterDelay]="500"
        [scrollable]="false"
        [globalFilterFields]="['numero','estado','tipoOrden']"
        currentPageReportTemplate="{first} - {last} de {totalRecords} registros"
        [showCurrentPageReport]="true"
        [rowsPerPageOptions]="rowsPerPageOptions"
        responsiveLayout="stack"
        [breakpoint]="'960px'">

        <ng-template pTemplate="caption">
          <div class="flex flex-col gap-4 py-2">
            <div class="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
              <div class="w-full md:max-w-96">
                <span class="p-input-icon-left w-full search-input-wrapper">
                  <i class="pi pi-search search-icon"></i>
                  <input
                    type="text"
                    pInputText
                    [(ngModel)]="filterValue"
                    (input)="dt.filterGlobal(filterValue, 'contains')"
                    placeholder="Buscar por número o cliente principal"
                    class="w-full"
                  />
                </span>
              </div>

              <div class="flex flex-wrap items-center gap-2.5">
                <button
                  pButton
                  type="button"
                  [label]="paginate ? 'Paginado' : 'Todos'"
                  [icon]="paginate ? 'pi pi-lock' : 'pi pi-lock-open'"
                  class="p-button-outlined p-button-sm"
                  (click)="paginate = !paginate; cargar()">
                </button>
                <button
                  pButton
                  type="button"
                  label="Limpiar"
                  icon="pi pi-filter-slash"
                  class="p-button-outlined p-button-sm"
                  (click)="clear(dt)">
                </button>
                <button
                  pButton
                  type="button"
                  label="Nueva orden"
                  icon="pi pi-plus"
                  class="p-button-sm"
                  (click)="navigateToCreateOrden()">
                </button>
              </div>
            </div>
          </div>
        </ng-template>

        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns"
                [pSortableColumn]="col.sortable ? col.field : ''"
                class="px-4 py-3.5 text-left text-xs font-semibold uppercase tracking-wide">
              <div class="flex items-center justify-between gap-2">
                <span>{{ col.header }}</span>
                <div class="flex items-center gap-2">
                  <p-sortIcon *ngIf="col.sortable" [field]="col.field"></p-sortIcon>
                  <p-columnFilter
                    *ngIf="col.filtrable"
                    [type]="col.fieldType === 'number' ? 'numeric' : 'text'"
                    [field]="col.field"
                    [display]="col.modeDisplayFilter || 'menu'"
                    [showMatchModes]="false"
                    [matchMode]="col.fieldType === 'number' ? 'equals' : 'contains'"
                    [showOperator]="false"
                    [showAddButton]="false">
                  </p-columnFilter>
                </div>
              </div>
            </th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-orden let-columns="columns">
          <tr class="transition-colors">
            <td *ngFor="let col of columns" [ngSwitch]="col.field" class="px-4 py-4">
              <span *ngSwitchCase="'numero'" class="font-medium">{{ orden.numero || '-' }}</span>

              <span *ngSwitchCase="'clientePrincipal'">
                {{ getClientePrincipal(orden) }}
              </span>

              <div *ngSwitchCase="'vigencia'" class="flex flex-col gap-1">
                <span>{{ orden.vigenciaDesde | dateCustom:'dd/MM/yyyy' }}</span>
                <span class="text-xs text-muted">{{ orden.vigenciaHasta | dateCustom:'dd/MM/yyyy' }}</span>
              </div>

              <span *ngSwitchCase="'estado'" class="app-badge text-xs" [ngClass]="getEstadoBadgeClass(orden.estado)">
                {{ getEstadoLabel(orden.estado) }}
              </span>

              <span *ngSwitchCase="'tipoOrden'">{{ orden.tipoOrden || '-' }}</span>

              <span *ngSwitchCase="'montoTotal'">{{ orden.montoTotal | currencyFormat }}</span>

              <div *ngSwitchCase="'accion'" class="flex items-center gap-2">
                <button
                  pButton
                  type="button"
                  icon="pi pi-pencil"
                  class="p-button-rounded p-button-text p-button-sm"
                  pTooltip="Editar"
                  tooltipPosition="top"
                  (click)="editarOrden(orden.id)">
                </button>
                <button
                  pButton
                  type="button"
                  icon="pi pi-download"
                  class="p-button-rounded p-button-text p-button-sm"
                  pTooltip="Exportar JSON"
                  tooltipPosition="top"
                  (click)="exportarOrden(orden)">
                </button>
              </div>

              <span *ngSwitchDefault>{{ orden[col.field] || '-' }}</span>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </section>
  </div>
</div>
